import { MaterialRequestFormSource } from "../constants/material-request.constants";

export function getMaterialRequestFromJobPath(
  sourceType:
    | typeof MaterialRequestFormSource.WORK_ORDER
    | typeof MaterialRequestFormSource.PETTY_WORK,
  jobId: number,
): string {
  if (sourceType === MaterialRequestFormSource.WORK_ORDER) {
    return `/inventory-management/material-requests/new/from-work-order/${jobId}`;
  }
  return `/inventory-management/material-requests/new/from-petty-work/${jobId}`;
}
